import { render, staticRenderFns } from "./lottery-admin.vue?vue&type=template&id=178b32da&scoped=true"
import script from "./lottery-admin.vue?vue&type=script&lang=js"
export * from "./lottery-admin.vue?vue&type=script&lang=js"
import style0 from "./lottery-admin.vue?vue&type=style&index=0&id=178b32da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178b32da",
  null
  
)

export default component.exports